// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"

// ** Axios Imports
import axios from "axios"

// ** Constants
import { API_PROMOTIONS_URL } from "../constants"

export const getListPromotionsByCompany = createAsyncThunk(
  "promotions/getListPromotionsByCompany",
  async ({
    page = 1,
    limit = 20,
    search,
    status,
    company,
    groups,
    section
  } = {}) => {

    let queryParams = `page=${page}&limit=${limit}`
    if (search) {
      queryParams += `&search=${search}`
    }
    if (status) {
      queryParams += `&status=${status}`
    }
    if (company) {
      queryParams += `&company=${company}`
    }
    if (groups) {
      queryParams += `&groups=${groups}`
    }
    if (section) {
      queryParams += `&section=${section}`
    }
    const response = await axios.get(`${API_PROMOTIONS_URL}?${queryParams}`)
    return response.data
  }
)

export const storePromotion = createAsyncThunk(
  "promotions/storePromotion",
  async (data, { dispatch, getState }) => {
    const response = await axios.post(
      `${API_PROMOTIONS_URL}/web`,
      data
    )
    return response.data
  }
)

export const updatePromotion = createAsyncThunk(
  "promotions/updatePromotion",
  async (data, { dispatch, getState }) => {
    const response = await axios.put(
      `${API_PROMOTIONS_URL}/web/${data._id}`,
      data
    )
    return response.data
  }
)

export const uploadCoverImagePromotion = createAsyncThunk(
  "promotions/uploadCoverImagePromotion",
  async (data, { dispatch, getState }) => {

    const formData = new FormData()
    formData.append('files', data.file[0])
    const axiosConfig = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }

    const response = await axios.post(
      `${API_PROMOTIONS_URL}/upload/cover-image/${data.promotionId}`,
      formData,
      axiosConfig
    )
    return response.data
  }
)

export const removeImage = createAsyncThunk(
  "promotions/removeImage",
  async (data, { dispatch, getState }) => {
    const response = await axios.delete(
      `${API_PROMOTIONS_URL}/images/remove/${data.promotionId}/${data.index}/${data.section}`
    )
    return response.data
  }
)

export const uploadImageGalleryPromotion = createAsyncThunk(
  "promotions/uploadImageGalleryPromotion",
  async (data, { dispatch, getState }) => {
    const formData = new FormData()
    formData.append('files', data.file[0])
    formData.append('description', data.description)
    formData.append('isEdit', data.isEdit)
    const axiosConfig = {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }

    const response = await axios.post(
      `${API_PROMOTIONS_URL}/upload/image-gallery/${data.promotionId}/${data.index}`,
      formData,
      axiosConfig
    )
    return response.data
  }
)

export const updateImageDescription = createAsyncThunk(
  "promotions/updateImageDescription",
  async (data, { dispatch, getState }) => {
    const response = await axios.put(
      `${API_PROMOTIONS_URL}/update/image-gallery/description/${data.promotionId}/${data.index}`,
      data
    )
    return response.data
  }
)

const _STATUS_OPTIONS = [
  { value: 'active', label: 'ACTIVO' },
  { value: 'inactive', label: 'INACTIVO' }
]

const initPromoData = {
  title: "",
  description: "",
  coverImage: "",
  images: [],
  price: "",
  ivaApplies: null,
  discountPorcent: "",
  group: null,
  tag: '',
  restrictions: '',
  validity: '',
  startDate: '',
  endDate: '',
  refundApplies: 'no',
  refundConditions: {
    time: '',
    cost: '',
    text: ''
  },
  deliveryTimeAprox: {
    status: _STATUS_OPTIONS[1],
    value: ''
  },
  participations: {
    status: _STATUS_OPTIONS[0],
    value: '',
    iva: false
  },
  percentagePointsPersonal: {
    status: _STATUS_OPTIONS[0],
    value: ''
  },
  percentagePointsReferred: {
    status: _STATUS_OPTIONS[0],
    value: ''
  },
  percentagePointsEmployee: {
    status: _STATUS_OPTIONS[0],
    value: ''
  },
  needApprove: false,
  _id: null,
  status: 'temp'
}

export const promotionsSlice = createSlice({
  name: "promotions",
  initialState: {
    list: [],
    totalPages: 1,
    loading: true,
    hasNextPage: false,
    pagingCounter: 0,
    totalDocs: 0,
    promotion: initPromoData
  },
  reducers: {
    handleGetPromotionData: (state, action) => {
      state.promotion = action.payload || initPromoData
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListPromotionsByCompany.pending, (state, action) => {
        state.loading = true
      })
      .addCase(getListPromotionsByCompany.fulfilled, (state, action) => {
        console.log(`LIST`, action.payload.docs)
        state.list = action.payload.docs
        state.totalPages = action.payload.totalPages
        state.hasNextPage = action.payload.hasNextPage
        state.pagingCounter = action.payload.pagingCounter
        state.totalDocs = action.payload.totalDocs
        state.loading = false
      })
  }
})

export const { handleGetPromotionData } = promotionsSlice.actions

export default promotionsSlice.reducer
